export const saveString2File = (fileContent, fileName) => {
    const a = document.createElement('a');
    a.setAttribute('href', 'data:text/json;charset=utf-8,' + fileContent);
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
        document.body.removeChild(a);
    }, 0);
}
